import { render, staticRenderFns } from "./NavigationBar.vue?vue&type=template&id=05bb39aa&"
import script from "./NavigationBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports